import { IPrescriptionStatuses } from './prescriptions';
import { api } from 'API';
import { addImposterToUrl } from 'Utils';
import { IMedication } from './medications';

const baseUrl = '/Order';

export interface IOrder extends IPrescriptionStatuses {
  notes: string;
  medications: IMedication[];
  date: string;
  code: number;
  createDate: string;
  monthsAmount: number;
  isSplitedPerMonths?: boolean;
}

export const getOrders = async (pageSize?: number, pageNumber?: number) => {
  const query =
    pageSize && pageNumber
      ? `?pageSize=${pageSize}&pageNumber=${pageNumber}`
      : '';
  const res = await api.get<IOrder[]>(addImposterToUrl(baseUrl + query, false));
  if (res.data) {
    return res.data;
  }
};

export const postOrders = async (
  order: Omit<
    Omit<
      Omit<
        Omit<Omit<Omit<IOrder, 'date'>, 'code'>, 'isManual'>,
        'currentStatus'
      >,
      'createDate'
    >,
    'statuses'
  >
) => {
  const orderData = await api.post<IOrder[]>(
    addImposterToUrl(baseUrl, true),
    order
  );
  if (orderData.data) {
    return orderData.data;
  }
};
